<template>
  <DatatableReportV3
    ref="datatable"
    download-url="/transactions"
    title="Payments"
    :source="source"
    :config="config"
    :filters="filters"
    @draw-complete="onDrawComplete"
  />
</template>

<script>
import CONSTANTS from "@/Constants";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";
import PaymentActionsContextMenu from "./PaymentsActionsContextMenu.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      voidTransactionID: null,
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "transaction_date",
            title: "Date",
            filterName: "created_at"
          },
          { data: "invoice" },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "job" },
          {
            data: "department",
            filterName: "department_id"
          },
          {
            data: "receiver",
            title: "Received By",
            filterName: "transaction_received_by",
            orderable: false,
            searchable: false
          },
          {
            data: "transaction_type",
            title: "Method"
          },
          {
            data: "entry_method",
            title: "Entry Method"
          },
          {
            data: "status",
            title: "Status"
          },
          {
            data: "processor_name",
            title: "Processor",
            searchable: false
          },
          {
            data: "amount_cents",
            title: "Amount",
            className: "text-right",
            searchable: false,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.total
          },
          {
            data: "txn_type",
            filterName: "txn_type",
            className: "txn-type-field",
            searchable: false,
            title: "Type"
          },
          {
            data: "reconciled",
            title: "Completed",
            className: "text-center",
            searchable: false
          },
          {
            data: "processor_tx_id",
            title: "Details",
            orderable: false
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          },
          {
            data: "processor_tx_id_for_modal",
            visible: false
          }
        ],
        vueComponents: [
          {
            rootId: "payments-context-menu-vue",
            component: PaymentActionsContextMenu,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.refreshTable();
    },
    onDrawComplete() {
      const self = this;
      // Handle reconciled checkbox
      $(".reconciled-checkbox")
        .off("change")
        .on("change", function (e) {
          const transaction_id = $(this).data("id");
          const reconciled_status = e.target.checked;
          self.updateReconciled(transaction_id, reconciled_status);
        });

      // Handle void modal link
      $(".void-modal-toggle")
        .off("click")
        .on("click", (e) => {
          this.voidTransactionID = $(e.target).data("transactionId");
          const transactionType = $(e.target).data("transactionType");
          const externalSystemWarningTypes = ["card", "external"];
          if (externalSystemWarningTypes.includes(transactionType)) {
            $(".external-warning-message").show();
          } else {
            $(".external-warning-message").hide();
          }
          $("#void_modal").modal("show");
        });

      // Handle void modal submit
      $("#void_modal").on("shown.bs.modal", () => {
        $(".void-modal-submit-btn")
          .off("click")
          .on("click", () => {
            this.updateVoided();
          });
      });
    },
    updateReconciled(transaction_id, reconciled_status) {
      $.ajax(`${window.location.pathname}/${transaction_id}`, {
        method: "PUT",
        dataType: "json",
        data: {
          transaction: { reconciled: reconciled_status }
        },
        success: () => {
          const status = reconciled_status ? "completed" : "incomplete";
          window.notify.success(`Payment marked as ${status}.`);
          this.refreshTable();
        },
        error: (e) => {
          window.notify.error(
            (e.responseJSON || {}).message || "Unable to update payment status."
          );
        }
      });
    },
    updateVoided() {
      $.ajax(`${window.location.pathname}/${this.voidTransactionID}`, {
        method: "PUT",
        dataType: "json",
        data: {
          transaction: { voided: true }
        },
        success: () => {
          $("#void_modal").modal("hide");
          window.notify.success("Transaction voided successfully!");
          this.voidTransactionID = null;
          this.refreshTable();
        },
        error: (e) => {
          window.notify.error(
            (e.responseJSON || {}).message || "Unable to void transaction."
          );
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
